import React, { useState, useRef, useEffect } from 'react';
import './Contact.css';

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('revealed'); obs.unobserve(e.target); }
      }),
      { threshold: 0.12 }
    );
    ref.current.querySelectorAll('.reveal').forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);
  return ref;
}

export default function Contact() {
  const bodyRef = useReveal();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    const mailto = `mailto:jim@getflarechat.com?subject=${encodeURIComponent(form.subject || 'FlareChat Inquiry')}&body=${encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`)}`;
    window.location.href = mailto;
    setSent(true);
  };

  return (
    <div className="contact-page" ref={bodyRef}>
      {/* Hero */}
      <section className="contact-hero">
        <div className="contact-hero-orb" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="section-tag animate-fade-up" style={{ background: 'rgba(244,97,26,0.2)', color: '#FFAD6F', borderColor: 'rgba(244,97,26,0.35)', margin: '0 auto 20px' }}>
            <span className="dot" style={{ background: '#F5A623' }} />
            Get in Touch
          </div>
          <h1 className="contact-heading animate-fade-up delay-1">We're here<br/><span className="gradient-text">to help.</span></h1>
          <p className="contact-sub animate-fade-up delay-2">
            Have questions, feedback, or need support? Reach out and we'll respond as soon as possible.
          </p>
        </div>
      </section>

      <section className="contact-body">
        <div className="container">
          <div className="contact-grid">
            {/* Left info */}
            <div className="contact-info reveal">
              <div className="info-card">
                <div className="info-icon">📧</div>
                <h3>General Inquiries</h3>
                <p>For any questions about FlareChat.</p>
                <a href="mailto:jim@getflarechat.com" className="info-link">jim@getflarechat.com</a>
              </div>

              <div className="info-card">
                <div className="info-icon">🐛</div>
                <h3>Support & Bug Reports</h3>
                <p>Include your device type, app version, and a description of the issue.</p>
                <a href="mailto:jim@getflarechat.com" className="info-link">jim@getflarechat.com</a>
              </div>

              <div className="info-card">
                <div className="info-icon">⏰</div>
                <h3>Response Time</h3>
                <p>We typically respond within <strong>24–48 hours</strong>.</p>
              </div>

              <div className="info-card">
                <div className="info-icon">📍</div>
                <h3>Location</h3>
                <p>East Greenbush, NY</p>
              </div>
            </div>

            {/* Right form */}
            <div className="contact-form-wrap reveal delay-2">
              {sent ? (
                <div className="sent-msg">
                  <span className="sent-emoji">🔥</span>
                  <h3>Message Sent!</h3>
                  <p>Your email client has opened. We'll get back to you within 24–48 hours.</p>
                  <button className="btn-primary" onClick={() => setSent(false)} style={{ margin: '20px auto 0', display: 'flex' }}>
                    Send Another
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <h3>Send a Message</h3>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Your Name</label>
                      <input name="name" type="text" placeholder="Alex Johnson" value={form.name} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                      <label>Email Address</label>
                      <input name="email" type="email" placeholder="alex@example.com" value={form.email} onChange={handleChange} required />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Subject</label>
                    <input name="subject" type="text" placeholder="How can we help?" value={form.subject} onChange={handleChange} />
                  </div>
                  <div className="form-group">
                    <label>Message</label>
                    <textarea name="message" rows="6" placeholder="Tell us more about your question or issue..." value={form.message} onChange={handleChange} required />
                  </div>
                  <button type="submit" className="btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                    Send Message 🔥
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
